<div [class.breadcrumb-hidden]="!showBreadcrumbs">
    @if (items && items.length > 0) {
        <p-breadcrumb #breadcrumbElement [model]="items" [ariaLabel]="'shared.breadcrumb.ariaLabel' | transloco">
            <ng-template #item let-item>
                @if (item.command) {
                    <a class="p-breadcrumb-item-link" tabindex="0" (click)="item.command()" (keydown.enter)="item.command()" (keydown.space)="item.command(); $event.preventDefault()" style="cursor: pointer;">
                        <span class="p-breadcrumb-item-label tw-inline-block tw-min-w-0 tw-max-w-[120px] md:tw-max-w-[192px] tw-truncate tw-align-middle">{{ item.label }}</span>
                    </a>
                } @else if (item.url) {
                    <a class="p-breadcrumb-item-link" [uiSref]="item.url">
                        <span class="p-breadcrumb-item-label tw-inline-block tw-min-w-0 tw-max-w-[120px] md:tw-max-w-[192px] tw-truncate tw-align-middle">{{ item.label }}</span>
                    </a>
                } @else {
                    <span class="p-breadcrumb-item-label tw-inline-block tw-min-w-0 tw-max-w-[120px] md:tw-max-w-[192px] tw-truncate tw-align-middle">{{ item.label }}</span>
                }
            </ng-template>
            <ng-template #separator> 
                <span class="p-breadcrumb-separator"> > </span>
            </ng-template>
        </p-breadcrumb>
    }
</div>
